module.exports = __webpack_public_path__ + "img/headphones.c2562922.png";